module.exports = __webpack_public_path__ + "img/t_0018.df4ae45f.gif";